/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_INITIAL_STATE = `${ PREFIX_EVENTS_STORE }/CLASSIC_BLOCK/SET_INITIAL_STATE`;

export const SET_CLASSIC_DETAILS_TITLE = `${ PREFIX_EVENTS_STORE }/SET_CLASSIC_DETAILS_TITLE`;
export const SET_CLASSIC_ORGANIZERS_TITLE = `${ PREFIX_EVENTS_STORE }/SET_CLASSIC_ORGANIZERS_TITLE`;
